import { render, staticRenderFns } from "./WheelsetAxleBasedata.vue?vue&type=template&id=76733bb1&scoped=true"
import script from "./WheelsetAxleBasedata.vue?vue&type=script&lang=js"
export * from "./WheelsetAxleBasedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76733bb1",
  null
  
)

export default component.exports